export default __webpack_public_path__ + "static/hepatofelin-article-box-18721ff7540ac05a2a7307b58961bd27.jpg";